import { getWindowObject } from '@eventbrite/feature-detection';

export const logAmplitudeEvent = (eventName, eventData = {}) => {
    // This is short-term code for the Amplitude POC, so we're swallowing any possible
    // exceptions to reduce the potential for disruptions in apps being instrumented.
    // https://eventbrite.atlassian.net/browse/EB-183265
    try {
        const data = {
            // Every step in the use case funnel for the POC requires the page_path property
            page_path: getPagePath(),
            ...eventData,
        };

        const amplitude = getWindowObject('amplitude');

        if (amplitude) {
            amplitude.getInstance('poc').logEvent(eventName, data);
        }
    } catch (e) {}
};

const getPagePath = () => {
    const location = getWindowObject('location');

    return location?.pathname || '';
};
